import React from 'react';
import s from './Card.module.scss';
import { useNavigate } from 'react-router-dom';
const Card = ({ data }) => {
  const services = data?.services || [];
  const navigate = useNavigate();

  return (
    <div className={s.cards}>
      {services?.map(item => {
        return (
          <div
            onClick={() => navigate(`/salon-details/${item?.id}`)}
            key={item.id}
            className={s.cards_card}
            style={{
              backgroundImage: `url(${item.image})`,
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className={s.cards_card_text}>
              <div className={s.cards_card_text_title}>{item.name}</div>
              <div className={s.cards_card_text_description}>{item.description}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Card;
